import { TCS } from "@/constants/TCS/TCS"

export const getWorkflowsProgressPercentage = (
  workflowsCount: number
) => {
  return (workflowsCount / TCS.TARGET_WORKFLOWS_COUNT) * 100
}
